// extracted by mini-css-extract-plugin
export default {"root":"coVeqg9A","button":"Z1hDPdta","active":"n4B_XQD7","icon":"LiXPZbz6","label":"V7ekAyLv"};